import ProvisioningLogs from "views/ProvisioningLogs";
import ServerRegions from "views/ServerRegions";
import ItemProgress from "views/ItemProgress";
import React from "react";
import APIReset from "views/APIReset";
import SwitchCustodian from "views/SwitchCustodianVersion";
import AADConfig from "views/AADToggle";
import LoggingUtilities from "views/LoggingUtilities";
import BotUtilities from "views/BotUtilities";
import ScheduledTriggerUtilities from "views/ScheduledTriggerUtilities";
import ListUtilities from "views/ListUtilities";
import ClearQueue from "views/ClearQueue";
import UpdateMaxJobs from "views/UpdateMaxJobs";
import FeatureFlags from "views/FeatureFlags";
import ICD from "views/ICD";
import BatchSize from "views/BatchSize";
import CCActions from "views/CCActions";
import Statistics from "views/Statistics";
import MobileActions from "views/MobileActions";
import Admins from "views/Admins";
import Logs from "views/Logs";
import EntraCacheSync from "views/EntraCacheSync";
import IDMSyncRuns from "views/IDMSyncRuns";
import ManageClient from "views/ManageClient";
import Workflows from "views/Workflows";
import ServiceAccounts from "views/ServiceAccounts";
import Home from "views/Home";
import DuplicateRequests from "views/DuplicateRequests";

const dashboardRoutes = [
  {
    path: "/home",
    name: <div className="ms-font-l">Home</div>,
    icon: "pe-7s-home",
    component: Home,
    layout: "/portal",
  },
  {
    path: "/dashboard",
    name: <div className="ms-font-l">Region Servers</div>,
    icon: "pe-7s-global",
    component: ServerRegions,
    layout: "/portal",
  },
  {
    path: "/provisioning_logs",
    name: <div className="ms-font-l">Provisioning Engine</div>,
    icon: "pe-7s-gleam",
    component: ProvisioningLogs,
    layout: "/portal",
  },
  {
    path: "/items-in-progress",
    name: <div className="ms-font-l">Items in Progress</div>,
    icon: "pe-7s-server",
    component: ItemProgress,
    layout: "/portal",
  },
  {
    path: "/reset-api-key",
    name: <div className="ms-font-l">API Key Utilities</div>,
    icon: "pe-7s-refresh",
    component: APIReset,
    layout: "/portal",
  },
  {
    path: "/switch-custodian-version",
    name: <div className="ms-font-l">Switch Environment</div>,
    icon: "pe-7s-shuffle",
    component: SwitchCustodian,
    layout: "/portal",
  },
  {
    path: "/admins",
    name: <div className="ms-font-l">Admins</div>,
    icon: "pe-7s-user",
    component: Admins,
    layout: "/portal",
  },
  {
    path: "/toggle-aad",
    name: <div className="ms-font-l">Entra ID Configuration</div>,
    icon: "pe-7s-config",
    component: AADConfig,
    layout: "/portal",
  },
  {
    path: "/logging-utilities",
    name: <div className="ms-font-l">Logging Utilities</div>,
    icon: "pe-7s-headphones",
    component: LoggingUtilities,
    layout: "/portal",
  },
  {
    path: "/bot-utilities",
    name: <div className="ms-font-l">Bot Utilities</div>,
    icon: "pe-7s-glasses",
    component: BotUtilities,
    layout: "/portal",
  },
  {
    path: "/scheduled-trigger-utilities",
    name: <div className="ms-font-l">Scheduled Trigger Utilities</div>,
    icon: "pe-7s-timer",
    component: ScheduledTriggerUtilities,
    layout: "/portal",
  },
  {
    path: "/list-utilities",
    name: <div className="ms-font-l">List Utilities</div>,
    icon: "pe-7s-news-paper",
    component: ListUtilities,
    layout: "/portal",
  },
  {
    path: "/clear-queue",
    name: <div className="ms-font-l">Clear Queue</div>,
    icon: "pe-7s-less",
    component: ClearQueue,
    layout: "/portal",
  },
  {
    path: "/service-accounts",
    name: <div className="ms-font-l">Service Accounts</div>,
    icon: "pe-7s-users",
    component: ServiceAccounts,
    layout: "/portal",
  },
  {
    path: "/update-max-jobs",
    name: <div className="ms-font-l">Update Max Jobs</div>,
    icon: "pe-7s-edit",
    component: UpdateMaxJobs,
    layout: "/portal",
  },
  {
    path: "/feature-flags",
    name: <div className="ms-font-l">Feature Flags</div>,
    icon: "pe-7s-flag",
    component: FeatureFlags,
    layout: "/portal",
  },
  {
    path: "/statistics",
    name: <div className="ms-font-l">Statistics</div>,
    icon: "pe-7s-graph3",
    component: Statistics,
    layout: "/portal",
  },
  {
    path: "/mobile-actions",
    name: <div className="ms-font-l">Mobile Actions</div>,
    icon: "pe-7s-phone",
    component: MobileActions,
    layout: "/portal",
  },
  {
    path: "/ICD",
    name: <div className="ms-font-l">ICD Management</div>,
    icon: "pe-7s-share",
    component: ICD,
    layout: "/portal",
  },
  {
    path: "/batch-size",
    name: <div className="ms-font-l">Field Details Batch Size</div>,
    icon: "pe-7s-disk",
    component: BatchSize,
    layout: "/portal",
  },
  {
    path: "/cc-actions",
    name: <div className="ms-font-l">CC Actions</div>,
    icon: "pe-7s-photo-gallery",
    component: CCActions,
    layout: "/portal",
  },
  {
    path: "/logs",
    name: <div className="ms-font-l">Logs</div>,
    icon: "pe-7s-note2",
    component: Logs,
    layout: "/portal",
  },
  {
    path: "/entra-cache-sync",
    name: <div className="ms-font-l">Entra Cache Sync</div>,
    icon: "pe-7s-refresh-2",
    component: EntraCacheSync,
    layout: "/portal",
  },
  {
    path: "/idm-sync-runs",
    name: <div className="ms-font-l">IDM Sync Runs</div>,
    icon: "pe-7s-repeat",
    component: IDMSyncRuns,
    layout: "/portal"
  },
  {
    path: "/manage-client",
    name: <div className="ms-font-l">Manage Client</div>,
    icon: "pe-7s-id",
    component: ManageClient,
    layout: "/portal",
  },
  {
    path: "/workflows",
    name: <div className="ms-font-l">Workflows</div>,
    icon: "pe-7s-loop",
    component: Workflows,
    layout: "/portal",
  },
  {
    path: "/duplicate-requests",
    name: <div className="ms-font-l">Duplicate Requests</div>,
    icon: "pe-7s-copy-file",
    component: DuplicateRequests,
    layout: "/portal",
  },
];

export default dashboardRoutes;
